/* eslint-disable no-restricted-imports */
import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';

type EventObj = {
  eventAction: string;
  eventName: string;
  elementName: string;
  value: string;
  pos: string;
  actionType: string;
  label: string;
  targetURL?: string;
};

export const trackClick = (trackingService: TrackingServiceV2, eventObj: EventObj) => {
  const {
    eventAction,
    eventName,
    elementName,
    value,
    pos,
    actionType,
    label,
    targetURL = '',
  } = eventObj;
  const dataLayerEvent = {
    eventInfo: {
      eventAction,
      eventName,
    },
    attributes: {
      componentName: 'feature-gallery',
      label,
      targetURL,
      clickID: '',
      elementName,
      value,
      pos,
      actionType,
    },
  };

  trackingService.track({
    event: dataLayerEvent,
  });
};
